module.exports = __webpack_public_path__ + "media/public/img/Gondola-WHITE-01-00bebab0db4a01666bbe28126118d9d9.svg";